<div class="bg-white" [ngClass]="{'py-3 px-spacer-responsive': shouldDisplayCounter}">
  <div *ngIf="shouldDisplayCounter" class="font-weight-bold">
    <span>0 {{StaticMessage.DefaultEntityPluralNameLabel | staticMessage}}</span>
    <hr class="extended-responsive" />
  </div>

  <div
    class="d-flex flex-column align-items-center justify-content-center py-3 dropZoneComponent"
    appFileUploadDrop
    [isMultiple]="fileUploadConfig.multiple"
    [accept]="fileUploadConfig.accept"
    [sizeLimit]="fileUploadConfig.sizeLimit"
    [imageSizeLimit]="fileUploadConfig.imageSizeLimit"
    (filesDrop)="onFilesChanged($event)"
  >
    <mat-icon svgIcon="cloud-upload" class="icon--jumbo"></mat-icon>
    <h4 i18n="@@dprDetails.dprAttachmentsUpload.txtDropAttachment" class="mb-0" data-testId="title">
      Drop attachment here
    </h4>
    <p>
      <span *ngIf="fileUploadConfig.accept" data-testId="file-accepted-mesage">
        {{fileUploadConfig.accept | fileAcceptDisplay}}
      </span>
      <span *ngIf="fileUploadConfig.sizeLimitMessage" data-testId="size-limit-message">
        &nbsp;{{fileUploadConfig.sizeLimitMessage}}
      </span>
    </p>
    <p i18n="@@dprDetails.dprAttachmentsUpload.txtOr">-or-</p>
    <app-file-upload-button
      [uploadButtonTemplate]="uploadButtonTemplate"
      [isMultiple]="fileUploadConfig.multiple"
      [accept]="fileUploadConfig.accept"
      [sizeLimit]="fileUploadConfig.sizeLimit"
      [imageSizeLimit]="fileUploadConfig.imageSizeLimit"
      (filesChange)="onFilesChanged($event)"
    ></app-file-upload-button>
  </div>
</div>

<ng-template #uploadButtonTemplate let-onAddFiles>
  <button mat-flat-button color="secondary" (click)="onAddFiles()" data-testId="upload-file">
    <mat-icon svgIcon="file-import"></mat-icon>
    <span i18n="@@dprDetails.dprAttachmentsUpload.btnSelectFromComputer">Select from computer</span>
  </button>
</ng-template>
